module.exports = __webpack_public_path__ + "media/images/logo-d836c420a0977378b8001d3e1b70a7b13c8b0adc97ea58fa977eaa1a4a58626f.png";